module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Cooking/Shovel-c4e34ca05fd4cfb3b5502d2cf0e6023b.svg";